import dayjs from "dayjs";
import {
  getAllCustomers,
  getAllRequestTypes,
  getAllRoutes,
  getAllSearchRequestStatuses,
  searchRequest
} from "services/common";
import { dateFormat, TAG_TYPES, Y_CHECKER } from "utils/constants";
import { dataDogErrorLog, handleRefId } from "utils/helpers";
import { baseApi } from "../baseApi";

/**
 * @module requestSearchApi request search RTK Query endpoints
 */
export const requestSearchApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllCustomers: builder.query({
      queryFn: async (props) => {
        try {
          const response = await getAllCustomers(props);
          return {
            data: response?.map(({ number, name, customer_id }) => ({
              label: `${number} - ${name.trim()}`,
              value: customer_id,
              number: number
            }))
          };
        } catch (err) {
          const { refId, message } = handleRefId(err);
          dataDogErrorLog(message, "", { error: err }, refId);
          return { error: message };
        }
      },
      providesTags: [TAG_TYPES.customer]
    }),
    getAllRequestTypes: builder.query({
      queryFn: async (props) => {
        try {
          const response = await getAllRequestTypes(props);
          return {
            data: response?.map(({ descr, request_type_id }) => ({
              label: descr,
              value: request_type_id
            }))
          };
        } catch (err) {
          const { refId, message } = handleRefId(err);
          dataDogErrorLog(message, "", { error: err }, refId);
          return { error: message };
        }
      },
      providesTags: [TAG_TYPES.reqestType]
    }),
    getAllRoutes: builder.query({
      queryFn: async (props) => {
        try {
          const response = await getAllRoutes(props);
          return {
            data: response?.map(({ route_code }) => ({
              label: route_code,
              value: route_code
            }))
          };
        } catch (err) {
          const { refId, message } = handleRefId(err);
          dataDogErrorLog(
            message,
            `${process.env.REACT_APP_CF_URL_MODULE_REQUEST}/request/getvalidscheduledroutes`,
            {
              main_district_id: props.mainDistrictId,
              day_codes: props.dayCodes,
              error: err
            },
            refId
          );
          return { error: message };
        }
      },
      providesTags: [TAG_TYPES.route]
    }),
    getAllRequestStatuses: builder.query({
      queryFn: async (props) => {
        try {
          const response = await getAllSearchRequestStatuses(props);
          return {
            data: response?.map(({ status_code, request_status_id }) => ({
              label: status_code,
              value: request_status_id
            }))
          };
        } catch (err) {
          const { refId, message } = handleRefId(err);
          dataDogErrorLog(
            message,
            `${process.env.REACT_APP_CF_URL_MODULE_REQUEST}/request/getallrequeststatusrows`,
            { main_district_id: props.mainDistrictId, error: err },
            refId
          );
          return { error: message };
        }
      },
      providesTags: [TAG_TYPES.requestStatus]
    }),
    searchRequest: builder.mutation({
      queryFn: async (props) => {
        try {
          const response = await searchRequest(props);
          return {
            data: response
          };
        } catch (err) {
          const { refId, message } = handleRefId(err);
          dataDogErrorLog(
            message,
            `${process.env.REACT_APP_CF_URL_MODULE_REQUEST}/request/getsummaryrequestinfo`,
            {
              main_district_id: props.mainDistrictId,
              service_date_from: dayjs(props.serviceDateFrom).format(
                dateFormat.universalFormat
              ),
              service_date_to: dayjs(props.serviceDateTo).format(
                dateFormat.universalFormat
              ),
              request_type_id: props.requestTypeId,
              request_status_id: props.requestStatusId,
              customer_id: props.customerId,
              route_code: props.routeName,
              not_completed_flag: Y_CHECKER,
              limit_row_count_flag: Y_CHECKER,
              error: err
            },
            refId
          );
          return { error: message };
        }
      }
    })
  })
});
